import 'whatwg-fetch';
import { api } from 'config';
import PubSub from 'services/PubSub/';
import { consumer, ecommerce } from 'config/constants';

const suscribeNewsletter = (email, rut) => {
    let headers = {
        'x-api-key': api.apiKey,
        'Content-Type': 'application/json'
    }

    if(ecommerce.JumboTest){
        headers['x-consumer'] = consumer,
        headers['x-account'] = consumer
    }
    return fetch(api.user + `/user/newsletter/`,{
        method: 'POST',
        headers,
        body: JSON.stringify({
            "email": email,
            "document": rut
        })
    })
        .then(results => results.json())
        .then(() => true)
        .catch((e) => {
            /*eslint-disable no-console*/
            console.log(e);
            /*eslint-disable no-console*/
            PubSub.dispatch('error_503');
            return false
        });
}

const Newsletters = {
    suscribeNewsletter
}

export default Newsletters;
